import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TNKDateDropdownComponent } from '../../components/date-dropdown/date-dropdown.component';
export class TNKDateDropdownModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  declarations: [TNKDateDropdownComponent],
  exports: [TNKDateDropdownComponent],
  providers: [],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TNKDateDropdownModule_tsickle_Closure_declarations() {
/** @type {?} */
TNKDateDropdownModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKDateDropdownModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
